import React, { forwardRef } from 'react';

import type { ApparentGenderNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { Radio } from '@vlabs/uikit/components/controls/radio';

import { useWorkspaceFilters } from '../../useWorkspaceFilters';
import st from '../FilterPopovers.module.sass';

interface ApparentGenderOption {
  label: string;
  value: ApparentGenderNullableParameter[number];
}

function ApparentGenderFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { filters, updateFilters } = useWorkspaceFilters();
  const selectedGender = filters.apparent_gender;
  const options = EVENT_ENUMS.BODY_BASIC_ATTRIBUTES.APPARENT_GENDER.raw as ApparentGenderOption[];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedGender === undefined}
      onClickReset={() => updateFilters({ apparent_gender: undefined })}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {options.map((option) => (
          <Radio
            checked={selectedGender?.value === option.value}
            key={option.value}
            label={option.label}
            onChange={() => updateFilters({ apparent_gender: option })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const ApparentGenderFilterPopoverWithRef = forwardRef(ApparentGenderFilterPopover);
export { ApparentGenderFilterPopoverWithRef as ApparentGenderFilterPopover };
